import { Fragment } from "react";
import { useTranslation } from "react-i18next";

import { Alert, Divider } from "@mui/material";

import { ClientContent } from "../../../client-content/ClientContent";
import { useClientFileContext } from "../../../context/ClientFileContext";
import { InventoryUploadArea } from "../../components/inventory-upload-area/InventoryUploadArea";
import { IncomeSectionCard } from "../income/components/income-section-card/IncomeSectionCard";
import { DONATIONS_UPLOAD_AREA, DONATION_QUESTIONS, hasAnyYes } from "./DonationsView.utils";
import { AssetSettlementInfo } from "./components/asset-settlement-info/AssetSettlementInfo";
import { DonationQuestion } from "./components/donation-question/DonationQuestion";
import { useAssetDonations } from "./hooks/useAssetDonations";

const TAB = "clients.client.debtSettlement.assetInventory.donationsTab";

export function DonationsView() {
  const { t } = useTranslation();
  const { clientId } = useClientFileContext();
  const { formik, missingFields, onAddMove, onCancelMove } = useAssetDonations(clientId);

  return (
    <ClientContent formik={formik} missingFields={missingFields}>
      <IncomeSectionCard title={t(`${TAB}.title`)}>
        <Alert severity="info" sx={{ mb: 2 }}>
          {t(`${TAB}.period`)}
        </Alert>
        {DONATION_QUESTIONS.map((config, index) => (
          <Fragment key={config.key}>
            {index > 0 && <Divider />}
            <DonationQuestion
              formik={formik}
              config={config}
              infoContent={config.key === "assetSettlement" ? <AssetSettlementInfo /> : undefined}
            />
          </Fragment>
        ))}
        {hasAnyYes(formik.values.answers) && (
          <InventoryUploadArea
            clientId={clientId}
            formik={formik}
            config={DONATIONS_UPLOAD_AREA}
            label={t(`${TAB}.upload`)}
            onAddMove={onAddMove}
            onCancelMove={onCancelMove}
          />
        )}
      </IncomeSectionCard>
    </ClientContent>
  );
}
